<div class="container d-print-none">

    <div class="row justify-content-center">

        <ng-container *ngIf="list_Trip.length;else noResult">

            <div class="col-md-6 col-12 mt-3">

                <div class="card mb-3 shadow-sm" *ngFor="let item of list_Trip" (click)="openDetails(item)">

                    <div class="card-body pointer" style="background-color: #f1f5f9;">

                        <div class="d-flex justify-content-between align-items-center mb-3">

                            <span class="badge bg-gray text-dark fs-3">{{ item?.iTaxiLon_Trip | faNum }}</span>

                            <div class="d-flex align-items-center gap-2">

                                <div class="d-flex flex-column">

                                    <span class="badge mt-2" style="width: fit-content;"
                                        [ngClass]="item.tiTripStatus == 8 ? 'bg-danger' : item.tiTripStatus == 2 ? 'bg-warning text-dark' : 'bg-info text-dark' ">

                                        {{ item?.strTaxiLon_TripStatus_strComment }}

                                    </span>

                                </div>

                            </div>

                        </div>

                        <div class="d-flex justify-content-between align-items-center mb-3">

                            <div class="d-flex flex-column">

                                <span class="d-flex align-items-center justify-content-between">

                                    <mat-icon class="d-flex align-items-center ps-2">calendar_month</mat-icon>

                                    {{ item?.strTime | faNum }} - {{ item?.strDate | faNum }}

                                </span>

                            </div>

                        </div>

                        <div class="d-flex justify-content-between align-items-center">

                            <span *ngIf="item?.iAdvancePayment !== 0" class="text-success">

                                پیش پرداخت :

                                <b> {{ item?.iAdvancePayment | number: '1.0-0' | faNum }} ریال</b>

                            </span>

                        </div>

                        <!-- آدرس مبداء -->

                        <div class="d-flex justify-content-between align-items-center">
                            <span *ngIf="item?.strSAddress != ''" class="text-muted">
                                آدرس مبداء:
                                <b> {{ item?.strSAddress | faNum }} </b>
                            </span>
                        </div>

                        <!-- آدرس مقصد -->

                        <div *ngIf="item?.strDAddress != ''"
                            class="d-flex justify-content-between align-items-center mt-2">
                            <span class="text-muted">
                                آدرس مقصد:
                                <b> {{ item?.strDAddress | faNum }} </b>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </ng-container>

        <ng-template #noResult>
            <div class="not-found p-2">
                <img src="../../../../assets/imgs/no-results.png" alt="در حال حاضر درخواست فعالی ندارید!">
                <p class="my-3">در حال حاضر درخواست فعالی ندارید!</p>
                <button class="btn btn-success" routerLink="/taxilon/NewTrip"> رزرو تاکسی </button>
            </div>
        </ng-template>

    </div>

</div>

<div class="modal d-print-none fade dir " id="details" tabindex="4" role="dialog" aria-hidden="true">

    <div class="h-100 modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content bg-gray-soft" style="direction: rtl;max-height:100%;">

            <div class="modal-header d-flex justify-content-between border-0">

                <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
                <span>کد سفر : <b class="text-danger">{{postDetail?.iTaxiLon_Trip | faNum}}</b></span>
                <span (click)="goBack()" *ngIf="modalMode !== 1" class="d-flex">
                    <mat-icon>arrow_back</mat-icon>
                </span>

            </div>
            <div class="modal-body" style="overflow-y: auto;">

                <ng-container *ngIf="modalMode == 1">
                    <div class="central butt_options mb-2">
                        <button *ngIf="postDetail?.tiTripStatus == 0" class="btn btn-success" (click)="payInvoice()">
                            <mat-icon>payment</mat-icon>پرداخت
                        </button>
                        <button *ngIf="postDetail?.tiTripStatus == 8" class="btn btn-info">

                            <a class="text-dark d-flex" target="_blank"
                                [href]="['/taxilon/route/'+ postDetail?.iTaxiLon_Trip]">

                                <mat-icon>map</mat-icon>مسیر

                            </a>

                        </button>

                        <ng-container *ngIf="postDetail?.tiTripStatus >= 3 && postDetail?.tiTripStatus <= 8">

                            <button (click)="openCancelTrip(4)" class="btn btn-info">

                                <mat-icon>photo</mat-icon>

                                مدارک

                            </button>

                        </ng-container>

                        <button (click)="openCancelTrip(3)"
                            *ngIf="postDetail?.tiTripStatus == 8 && postDetail?.tiDriverPoints == 0"
                            class="btn btn-primary ">
                            <mat-icon>star</mat-icon>امتیاز سفر
                        </button>

                        <button (click)="openCancelTrip(2)" *ngIf="postDetail?.tiTripStatus <= 6"
                            class="btn btn-danger">
                            <mat-icon>clear</mat-icon>لغو
                        </button>
                    </div>

                    <div class="trip_detail central flex-column">

                        <span class="central justify-content-start">
                            <p>از</p>
                            <b>{{postDetail?.strSCityName}}</b>
                            <div class="route_img">
                                <img class="route_img1" src="../../../../assets/imgs/taxi-icon.png" alt="">
                                <img class="route_img2" src="../../../../assets/imgs/arrow.png" alt="">
                                <img class="route_img3" src="../../../../assets/imgs/dest-flag.png" alt="">
                            </div>
                            <p>به</p>
                            <b>{{postDetail?.strDCityName}}</b>
                        </span>

                        <div class="central trip_status py-3">
                            <h4>
                                {{postDetail?.strTaxiLon_TripStatus_strComment}} !
                            </h4>
                        </div>

                        <div *ngIf="postDetail?.tiTripStatus == 8" class="central flex-column trip_point py-1 dil">
                            <div *ngIf="postDetail?.tiDriverPoints == 1">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>
                            <div *ngIf="postDetail?.tiDriverPoints == 2">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>
                            <div *ngIf="postDetail?.tiDriverPoints == 3">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>
                            <div *ngIf="postDetail?.tiDriverPoints == 4">
                                <mat-icon>star_border</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>
                            <div *ngIf="postDetail?.tiDriverPoints == 5">
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                                <mat-icon>star</mat-icon>
                            </div>
                        </div>

                    </div>

                    <div class="central flex-column detailbox">

                        <ng-container *ngIf="postDetail?.tiTripStatus >= 3 && postDetail?.tiTripStatus <= 8">
                            <div class="driver_box">
                                <div class="central justify-content-between">
                                    <b>{{postDetail?.strDriver_FullName | faNum}} - {{ postDetail?.strDriver_Mobile |
                                        faNum }} </b>
                                    <img *ngIf="postDetail?.strAvatar"
                                        src="data:image/png;base64,{{postDetail?.strAvatar}}" alt="profile">
                                    <img *ngIf="!postDetail?.strAvatar"
                                        src="../../../../assets/imgs/avatar-default-icon.png" alt="profile">
                                </div>
                                <div class="central justify-content-between mt-2">
                                    <b>{{postDetail?.strMobileGroup_strComment |faNum}} ،
                                        {{postDetail?.strGPSType_strComment |faNum}} - {{postDetail?.strColor |faNum}}
                                    </b>

                                    <span class="m-0">
                                        <div class="container_plate">
                                            <div class="license-plate">
                                                <div class="blue-column">
                                                    <div class="flag">
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                    <div class="text">
                                                        <div>I.R.</div>
                                                        <div>IRAN</div>
                                                    </div>
                                                </div>
                                                <b>{{postDetail?.strVehicleNo | faNum}} </b>

                                                <!-- <span>
                                                    ۲۶
                                                </span>
                                                <span class="alphabet-column">
                                                    ی
                                                </span>
                                                <span>
                                                    ۸۳۷
                                                </span>
                                                <div class="iran-column">
                                                    <span>ایــران</span>
                                                    <strong>۲۰</strong>
                                                </div> -->
                                            </div>
                                        </div>
                                    </span>

                                </div>
                            </div>

                        </ng-container>



                        <div class="central justify-content-between">
                            <span>تاریخ</span>
                            <b>{{postDetail?.strTime |faNum}} - {{postDetail?.strDate |faNum}}</b>
                        </div>
                        <!-- <div class="central justify-content-between">
                            <span>ساعت</span>
                            <b></b>
                        </div> -->
                        <!-- <div *ngIf="postDetail?.tiTripStatus <= 3 || postDetail?.tiTripStatus >= 8" class="central justify-content-between">
                            <span>نوع خودرو</span>
                            <b>{{postDetail?.strMobileGroup_strComment |faNum}} </b>
                        </div> -->
                        <div class="central justify-content-between">
                            <span>تعداد مسافران </span>
                            <b>{{postDetail?.tiPassenger |faNum}} نفر</b>
                        </div>
                        <div class="central justify-content-between">
                            <span> پیش پرداخت </span>
                            <b>{{postDetail?.iAdvancePayment | number: '1.0-0' |faNum}} ریال</b>
                        </div>
                        <div *ngIf="postDetail?.bForAnother" class="central justify-content-between">
                            <span> نام مسافر </span>
                            <b>{{postDetail?.strPassengersName | faNum}} </b>
                        </div>
                        <div class="central justify-content-start">
                            <span> آدرس مبدا: </span>
                            <address class="mb-0 fw-bold ms-auto">{{postDetail?.strSAddress|faNum}}</address>
                            <i class="fa fa-map-marker fa-lg bg-warning px-3 py-2 rounded pointer"
                                title="نمایش بر روی نقشه"
                                (click)="showMap([postDetail.fSLat,postDetail.fSLon,postDetail.strSAddress])">

                            </i>
                        </div>

                        <!-- آدرس مقصد -->
                        <ng-container *ngIf="postDetail?.strDAddress.trim() != ''">
                            <div class="central justify-content-start">
                                <span> آدرس مقصد: </span>
                                <address class="mb-0 fw-bold ms-auto">{{postDetail?.strDAddress|faNum}}</address>
                                <i *ngIf="postDetail?.fDLat != 0 && postDetail?.fDLon != 0"
                                    class="fa fa-map-marker fa-lg bg-warning px-3 py-2 rounded pointer"
                                    title="نمایش بر روی نقشه"
                                    (click)="showMap([postDetail.fDLat,postDetail.fDLon,postDetail.strDAddress])">
                                </i>
                            </div>
                        </ng-container>

                        <div *ngIf="postDetail?.bCargo" class="central justify-content-start">
                            <span> مشخصات بار : </span>
                            <b>{{postDetail?.strCargoDetail |faNum}} </b>
                        </div>
                        <div *ngIf="postDetail?.strComment !== ''" class="central justify-content-start">
                            <span> توضیحات سفر : </span>
                            <b>{{postDetail?.strComment |faNum}} </b>
                        </div>
                        <div class="central justify-content-between">
                            <span> رفت و برگشت </span>
                            <b class="d-flex text-success" *ngIf="postDetail?.bCameback">
                                <mat-icon>check</mat-icon>
                            </b>
                            <b class="d-flex text-danger" *ngIf="!postDetail?.bCameback">
                                <mat-icon>close</mat-icon>
                            </b>
                        </div>
                        <div *ngIf="postDetail?.tiTripStatus == 10" class="central justify-content-start">
                            <span> توضیحات لغو سفر : </span>
                            <b>{{postDetail?.strPassenger_CancelReason |faNum}} </b>
                        </div>

                        <ng-container *ngIf="postDetail?.tiTripStatus == 8">
                            <div class="central justify-content-between">
                                <span> ساعت شروع سفر </span>
                                <b>{{postDetail?.strSTripTime | faNum}} </b>
                            </div>
                            <div class="central justify-content-between">
                                <span> تاریخ و ساعت پایان سفر </span>
                                <b>{{postDetail?.strEndFullTime | faNum }} </b>
                            </div>
                            <div class="central justify-content-between">
                                <span> مدت سفر </span>
                                <b>{{postDetail?.strTripTime_Minute | faNum}} </b>
                            </div>
                            <div class="central justify-content-between">
                                <span> پیمایش سفر (km) </span>
                                <b>{{postDetail?.fFinalKm | faNum}} </b>
                            </div>
                            <div class="central justify-content-between">
                                <span> مدت توقف در حین سفر </span>
                                <b>{{postDetail?.strFinalStopTime_Minute | faNum}} </b>
                            </div>
                            <div class="central justify-content-between">
                                <span> هزینه کل </span>
                                <b class="text-success">{{postDetail?.iFinalRent | number: '1.0-0' |faNum}} ریال</b>
                            </div>

                            <div *ngIf="postDetail?.iDiscount" class="central justify-content-between">

                                <span> تخفیف </span>

                                <b class="text-danger">

                                    {{postDetail?.iDiscount | number: '1.0-0' |faNum}} ریال

                                </b>

                            </div>

                        </ng-container>

                        <button (click)="printInvoice()" *ngIf="postDetail?.tiTripStatus == 8"
                            class="central btn btn-primary bg-gray w-100 p-1">

                            <mat-icon>receipt</mat-icon>صدور فاکتور

                        </button>

                    </div>
                </ng-container>

                <ng-container *ngIf="modalMode == 2">

                    <div class="form-group w-100 has-icon mb-3">

                        <label class="text-danger text-large m-0 mb-1"> دلیل لغو سفر </label>


                        <span class="form-control-icon">

                            <mat-icon class="mat-18">comment</mat-icon>

                        </span>

                        <textarea style="height:75px;" type="text" class="w-100 mb-3 form-control border-red"
                            [(ngModel)]="strPassenger_CancelReason" placeholder="نوشتن دلیل الزامی است"></textarea>


                    </div>

                    <div class=" central w-100 justify-content-between price_offer">
                        <div class="w-100 mx-1">
                            <button (click)="goBack()" class="w-100 btn btn-third px-4">
                                انصراف </button>
                        </div>
                        <div class="w-100 mx-1">
                            <button (click)="cancelTrip(postDetail?.iTaxiLon_Trip)" class="w-100 btn btn-primary px-4">
                                ثبت
                            </button>
                        </div>
                    </div>

                </ng-container>

                <ng-container *ngIf="modalMode == 3">

                    <span class="central text-large">

                        لطفا میزان رضایت خود از سفر را وارد نمایید

                    </span>
                    <div class="my-3">
                        <star-rating [starType]="'svg'" [rating]="0" (ratingChange)="onRatingChange($event)">
                        </star-rating>
                    </div>

                    <div class="central justify-content-evenly mb-3 d-none">
                        <span>کمترین</span>
                        <img style="width: 100px;mix-blend-mode: darken;" src="../../../../assets/imgs/arrow_left.png"
                            alt="">
                        <span>بیشترین</span>
                    </div>

                    <ng-container *ngIf="currentRating != ''">

                        <div class="p-1">

                            <textarea class="w-100 form-control" style="height: 100px;"
                                placeholder="نظر خود را در رابطه با این سفر جهت نمایش در بخش نظرات تاکسی لون بفرمایید."
                                [(ngModel)]="currentRating.strPassengerOpinion">

                            </textarea>

                        </div>

                    </ng-container>

                    <div class=" central w-100 justify-content-between price_offer">
                        <div class="w-100 mx-1">
                            <button (click)="goBack()" class="w-100 btn btn-third px-4">
                                انصراف </button>
                        </div>
                        <div class="w-100 mx-1">
                            <button (click)="setTripRate(postDetail?.iTaxiLon_Trip)" class="w-100 btn btn-primary px-4">
                                ثبت
                            </button>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="modalMode == 4">
                    <div class="row">
                        <div class="col-6" *ngFor="let item of driverEvidence">
                            <div class="central justify-content-between flex-column evidence_box"
                                (click)="openDetailsimg(item)">
                                <img width="100" *ngIf="item?.strImage" src="data:image/png;base64,{{item?.strImage}}"
                                    alt="profile">

                                <span>
                                    {{item?.strEvidenceType_strComment}}
                                </span>

                            </div>
                        </div>
                    </div>


                </ng-container>

            </div>



        </div>

    </div>

</div>

<!-- مدال نقشه -->

<app-custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true" [skip_Search]="true"
    [isShowFooter]="false" (mdl_Submit)="showCustom_Map=false">

</app-custom-map>

<div class="modal d-print-none fade dir " id="detailsimg" tabindex="4" role="dialog" aria-hidden="true">

    <div class="h-100 image-modal modal-dialog modal-lg modal-dialog-centered">

        <div class="h-100 modal-content bg-gray-soft" style="direction: rtl;">

            <div class="modal-header d-flex justify-content-between border-0 p-0">



                <button type="button" class="btn-close m-0" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="h-100 modal-body central">


                <img class="" src="data:image/png;base64,{{mainImg}}" alt="profile">
                <!-- <img src="../../../../assets/imgs/Flag_of_the_United_Arab_Emirates.svg.png" alt="profile"> -->
                <!-- <img src="../../../../assets/imgs/Flag_of_the_United_Arab_Emirate_s.svg.png" alt="profile"> -->
            </div>



        </div>

    </div>

</div>

<!-- فاکتور سرویس -->

<div class="Invoice-container print-display row gx-0 gy-0 p-2">

    <div class="col-4 d-flex flex-column align-items-center justify-content-center py-2">

        <img src="../../../../assets/imgs/Shahrnik_Logo_Public_new.png" alt="">

        <p class="fw-bold my-2" style="font-size: 14px;">سامانه خدمات تاکسی شهری و بین شهری</p>

        <p class="fw-bold" style="font-size: 16px;"> www.taxilon.com </p>

    </div>

    <div class="col-8 row gx-0 gy-2 p-2">

        <div class="col-6"> شماره : {{ postDetail?.iTaxiLon_Trip | faNum }} </div>

        <div class="col-6"> تاریخ : {{ postDetail?.strDate | faNum }} </div>

        <div class="col-6"> نام مسافر :

            <span *ngIf="postDetail?.strCompany != '' "> {{ postDetail?.strCompany }} - </span>

            {{ postDetail?.strFullName }}

        </div>

        <div class="col-6"> تلفن : {{ postDetail?.strMobile | faNum }} </div>

        <div class="col-6"> کرایه : {{ postDetail?.iFinalRent | number:'1.0-0' | faNum }} ریال </div>

        <div class="col-6" *ngIf="postDetail?.iDiscount">

            تخفیف : {{ postDetail?.iDiscount | number:'1.0-0' | faNum }} ریال

        </div>

        <div class="col-6"> گروه خودرویی : {{ postDetail?.strMobileGroup_strComment }} </div>

        <div class="col-6"> راننده : {{ postDetail?.strDriver_FullName }} </div>

        <div class="col-6"> پلاک : {{ postDetail?.strVehicleNo | faNum }} </div>

        <div class="col-12"> مبداء : {{ postDetail?.strSAddress }} </div>

        <div class="col-12"> مقصد : {{ postDetail?.strDAddress }} </div>

        <div class="col-12" *ngIf="postDetail?.strComment.trim() != ''">

            توضیحات : "{{ postDetail?.strComment}}"

        </div>

        <div class="col-12 d-flex justify-content-end">

            <img src="../../../../assets/imgs/taxilon-signature.png" alt="">

        </div>

        <div class="col-12 mt-4">

            آدرس : {{ 'تهران – نارمک بزرگراه شهید سلیمانی بعد از چهارراه سرسبز پلاک 640' | faNum }}

            <p class="my-2"> تلفن : {{ '2-02177273160' | faNum }} </p>

        </div>

    </div>

</div>